import type { DocPageContent } from '../docs-content'

const page = {
  order: 15,
  slug: 'keyframes',
  title: '关键帧动画',
  description: '对变换、裁剪、文本、特效、蒙版和音频属性进行动画处理。',
  category: '创意工具',
  sections: [
    {
      title: '关键帧基础',
      items: [
        '为支持的属性添加关键帧。',
        '清除选中的属性关键帧或选中片段上的所有关键帧。',
        '当属性更改应自动创建动画时，使用自动关键帧模式。',
      ],
    },
    {
      title: '编辑器视图',
      items: [
        '使用"曲线图"视图查看曲线和手柄。',
        '使用"关键帧列表"视图查看时间和间距。',
        '当时间和曲线形状都重要时，使用"分割"视图。',
        '在局部和全局帧显示之间切换。',
      ],
    },
    {
      title: '编辑动画',
      items: [
        '使用保持、线性、缓入、缓出和缓入缓出等缓动预设。',
        '复制、剪切、粘贴和移动选中的关键帧。',
        '使用框选选择关键帧组。',
        '筛选参数以聚焦于活动的动画属性。',
      ],
    },
  ],
} satisfies DocPageContent

export default page